// Deterministic date formatter — produces identical output on Node (react-snap
// prerender) and in the browser, avoiding React hydration mismatch (#418) that
// occurs when `toLocaleDateString` relies on ICU locale data missing from Node.
//
// Input:  "YYYY-MM-DD" (from blogPosts.js)
// Output: e.g. "24 de fevereiro de 2026" (pt), "February 24, 2026" (en),
//         "24 février 2026" (fr).

const MONTHS = {
  pt: [
    "janeiro", "fevereiro", "março", "abril", "maio", "junho",
    "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
  ],
  en: [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ],
  fr: [
    "janvier", "février", "mars", "avril", "mai", "juin",
    "juillet", "août", "septembre", "octobre", "novembre", "décembre",
  ],
};

export const formatBlogDate = (iso, lang) => {
  if (!iso || typeof iso !== "string") return iso || "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  const year = m[1];
  const monthIdx = parseInt(m[2], 10) - 1;
  const day = String(parseInt(m[3], 10)); // strip leading zero
  const months = MONTHS[lang] || MONTHS.pt;
  const month = months[monthIdx] || "";
  if (lang === "en") return `${month} ${day}, ${year}`;
  if (lang === "fr") return `${day} ${month} ${year}`;
  return `${day} de ${month} de ${year}`;
};
